import { combineReducers } from 'redux'
import toggleMobileMenu from './toggleMobileMenu'

export default combineReducers({
    toggleMobileMenu,
})
